import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import fetch from "isomorphic-fetch";
import db from "../dbconn";
import {API_ROOT} from "../api-config";
import Modal from 'react-responsive-modal';
import axios from 'axios';
import Swal from "sweetalert2";
import moment from "moment";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';
class order_summary extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            nosessionredirect: false,
            windowHeight: 0,
            open: false,
            order_id: this.props.match.params.orderId,
            productList: [],
            nca: 0,
            ncaAmtFlag: false,
            tax: [],
            categoryList: [],
            orderData: [],
            editItemRedirectFlag: false,
            checkoutRedirectFlag: false,
            editItemProductID: 0,
            editItemCartID: 0,
            cartTotal: 0,
            subTotal: 0,
            finalTax: 0,
            guestRedirectFlag: false,
            swalButton: '',
            cartRedirect: false,
            storeOrderType: '',
            storeDeliveryFee: '',
            orderType: '',
            orderDeliveryFee: '',
            tip: 0,
            discount:0,
            timeSlot: '',
            dateSlot: '',
            tableName: '',

        };
    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {
        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        this.onOpenModal();


        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });

        var url = '';


        var dbconn = new db();

        dbconn.getAll().then(data => {

            if (!data || data.length < 1) {
                this.setState({nosessionredirect: true});
            } else {
                var customer_id = data[0].customer_id;
                var customer_token = data[0].customer_token;

                url = API_ROOT + '/fetchstorestats?guestFlag=N&customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');

                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(storeData => {

                        if (storeData.status == 1) {

                            this.setState({nca: storeData.store_data[0].store_default_nca});
                            this.setState({ncaAmtFlag: storeData.store_data[0].store_nca_amount_flag});
                            this.setState({ncaName: storeData.store_data[0].store_nca_name});
                            this.setState({storeOrderType: storeData.store_data[0].store_order_type});
                            this.setState({storeDeliveryFee: storeData.store_data[0].store_delivery_fee});


                            var url1 = API_ROOT + '/fetchorderbyid?customer_id=' + customer_id + '&customer_token=' + customer_token + '&order_id=' + this.state.order_id;

                            fetch(url1)
                                .then(response => {
                                    return response.json();
                                })
                                .then(orderData => {

                                    this.onCloseModal();

                                    if (orderData.status == 1) {


                                        var taxArray = orderData.order_data.order_tax;

                                        var totalTax = 0;

                                        console.log(taxArray.length);

                                        for (var i = 0; i < taxArray.length; i++) {

                                            var tax = ((parseFloat(orderData.order_data.order_amount) * parseFloat(taxArray[i].tax_percentage)) / 100);


                                            taxArray[i].tax_value = tax.toFixed(2);

                                            totalTax += parseFloat(tax.toFixed(2));
                                        }

                                        this.setState({tax: taxArray});
                                        this.setState({finalTax: totalTax.toFixed(2)});

                                        this.setState({productList: orderData.order_data.product_data});
                                        this.setState({tableName: orderData.order_data.table_name});
                                        this.setState({cartTotal: orderData.order_data.order_amount});
                                        this.setState({orderData: orderData.order_data});
                                        this.setState({nca: orderData.order_data.order_nca});
                                        this.setState({tip: orderData.order_data.order_tip});
                                        this.setState({discount: orderData.order_data.order_discount});
                                        this.setState({orderType: orderData.order_data.store_order_type});
                                        this.setState({orderDeliveryFee: orderData.order_data.order_delivery_charge});
                                        this.setState({subTotal: orderData.order_data.order_total});
                                        this.setState({timeSlot: orderData.order_data.order_time_slot});
                                        if (orderData.order_data.order_date_slot == "") {
                                            this.setState({dateSlot: ""});
                                        } else {
                                            this.setState({dateSlot: moment(orderData.order_data.order_date_slot, "YYYY-MM-DD").format('MMMM Do YYYY')});
                                        }
                                    }
                                });


                        }
                    });


            }
        });

    }

    componentDidMount() {

        document.title = "Order Summary - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});

        window.$('#nav-main').okayNav();


        $('#reorderThis').click(e => {
            var dbconn = new db();
            dbconn.getAll().then(data => {

                if (!data || data.length < 1) {
                    this.setState({nosessionredirect: true});
                } else {
                    var customer_id = data[0].customer_id;
                    var customer_token = data[0].customer_token;


                    this.onOpenModal();
                    axios.post(API_ROOT + '/reorder', {
                        order_id: this.state.order_id,
                        order_data: this.state.orderData,
                        customer_id: customer_id,
                        customer_token: customer_token,
                        store_id: localStorage.getItem("store_id"),
                    }).then((response) => {

                        this.onCloseModal();

                        if (response.data.status == 1) {


                            var dbconn = new db();

                            dbconn.deleteAllOrder();


                            var count = 0;
                            var cartTotal = 0;
                            //alert(response.data.order_data.product_data.length);


                            response.data.order_data.map((item, index) => {

                                item.cart_id = index + 1;


                                console.log(item.product_name);


                                dbconn.setOrder(item, index + 1).then(() => {
                                    count++;
                                    cartTotal += item.product_quantity * (item.product_price + item.mod_price);

                                    if (count == response.data.order_data.length) {


                                        sessionStorage.setItem('cartTotal', cartTotal);
                                        this.setState({cartRedirect: true});
                                    }
                                });


                            });


                        } else {

                            this.state.swalButton.fire({title: response.data.message, allowOutsideClick: false});
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            });
        });
    }


    render() {
        const {t} = this.props;
        const {open} = this.state;

        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        if (this.state.editItemRedirectFlag) {
            return (<Redirect to={'/menu'}/>);
        }
        if (this.state.checkoutRedirectFlag) {
            return (<Redirect to={'/checkout/card'}/>);
        }
        if (this.state.cartRedirect) {
            return (<Redirect to={'/order/view'}/>);
        }
        if (this.state.guestRedirectFlag) {
            return (<Redirect to={'/checkout/guest'}/>);
        }

        var submitBtnHtml = '';
        var finalNca = 0;


        if (this.state.order_id == 0) {

            if (this.state.ncaAmtFlag == 'Y') {
                finalNca = this.state.nca;
            } else {
                var nca = ((parseFloat(this.state.cartTotal) * parseFloat(this.state.nca)) / 100).toFixed(2);

                finalNca = nca;
            }


        }

        var deliveryVisible = "none";

        if (parseFloat(this.state.orderDeliveryFee) > 0) {
            deliveryVisible = "table-row";
        } else {
            deliveryVisible = "none";
        }
        var orderType = i18n.t("pickup");
        if (this.state.orderType == "D") {
            orderType = i18n.t("delivery");
        }
        if (this.state.orderType == "I") {
            orderType = i18n.t("dinein");
        }

        var backUrl = '';

        if (this.state.order_id == 0) {
            backUrl = '/menu';
        } else {
            backUrl = '/order/history';
        }

        return (
            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={backUrl}></Link>
                        <h2 className="text-center">{t('order_summary')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>
                <div className="mt-white full-height" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box m-b-0 p-b-35  bkg-white full-height m-grey"
                         style={{overflowY: "scroll",paddingBottom:"150px"}}>
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="form-box w-75 div-center">
                                <div className="header-title">
                                    <h2 className="text-center font-size-20 m-0">{t('order_details')}</h2>
                                </div>
                                <div className="header-content help_content">

                                    <table className="summaryTable">
                                        <tbody>
                                        <tr>
                                            <td>{t('order_number')}</td>
                                            <td></td>
                                            <td>#{this.state.orderData.order_check_number}</td>
                                        </tr>
                                        <tr>
                                            <td>{t('order_date')}</td>
                                            <td></td>
                                            <td>{this.state.orderData.order_created_at}</td>
                                        </tr>
                                        <tr>
                                            <td>{t('order_type')}</td>
                                            <td></td>
                                            <td>{orderType}</td>
                                        </tr>
                                        {(this.state.orderType == "I") ?

                                            <tr>
                                                <td>Table #
                                                </td>
                                                <td></td>
                                                <td>{this.state.tableName}</td>
                                            </tr>
                                            : ''
                                        }
                                        {(this.state.timeSlot != '') ?

                                            <tr>
                                                <td>{t('scheduled_for')}
                                                </td>
                                                <td></td>
                                                <td>{this.state.dateSlot} {this.state.timeSlot}</td>
                                            </tr>
                                            : ''
                                        }

                                        {this.state.productList.map((item, index) => {


                                            var productModifier = [];
                                            return (
                                                <tr key={item.product_id}>
                                                    <td>{(localStorage.getItem("store_language")==="en")?item.product_name:(item["product_name_"+localStorage.getItem("store_language")]!=="")?item["product_name_"+localStorage.getItem("store_language")]:item.product_name}
                                                        {item.product_modifiers.map((modifier1, index1) => {

                                                            if (productModifier.includes(modifier1.mod_id)) {

                                                            } else {

                                                                var modifier = ((localStorage.getItem("store_language") === "en") ? modifier1.mod_name : (modifier1["mod_name_" + localStorage.getItem("store_language")] !== "") ? modifier1["mod_name_" + localStorage.getItem("store_language")] : modifier1.mod_name)+ ": ";

                                                                var commaCount = 0;
                                                                item.product_modifiers.map((modifier2, index2) => {


                                                                    if (parseInt(modifier2.mod_id) == parseInt(modifier1.mod_id)) {

                                                                        if (modifier2.mod_selected == "Y") {
                                                                            if (commaCount > 0) {
                                                                                modifier += ", " + ((localStorage.getItem("store_language") === "en") ? modifier2.option_name : (modifier2["option_name_" + localStorage.getItem("store_language")] !== "") ? modifier2["option_name_" + localStorage.getItem("store_language")] : modifier2.option_name) + " " + ((modifier2.mod_price > 0) ? '($' + modifier2.mod_price.toFixed(2) + ')' : '');
                                                                            } else {
                                                                                modifier += ((localStorage.getItem("store_language") === "en") ? modifier2.option_name : (modifier2["option_name_" + localStorage.getItem("store_language")] !== "") ? modifier2["option_name_" + localStorage.getItem("store_language")] : modifier2.option_name) + " " + ((modifier2.mod_price > 0) ? '($' + modifier2.mod_price.toFixed(2) + ")" : '');
                                                                            }
                                                                            commaCount++;
                                                                        } else {

                                                                            if (modifier2.mod_default == "Y") {
                                                                                if (commaCount > 0) {
                                                                                    modifier += ","+i18n.t('no')+" " + ((localStorage.getItem("store_language") === "en") ? modifier2.option_name : (modifier2["option_name_" + localStorage.getItem("store_language")] !== "") ? modifier2["option_name_" + localStorage.getItem("store_language")] : modifier2.option_name) + " " + ((modifier2.mod_price > 0) ? '($' + modifier2.mod_price.toFixed(2) + ')' : '');
                                                                                } else {
                                                                                    modifier += i18n.t('no')+" " + ((localStorage.getItem("store_language") === "en") ? modifier2.option_name : (modifier2["option_name_" + localStorage.getItem("store_language")] !== "") ? modifier2["option_name_" + localStorage.getItem("store_language")] : modifier2.option_name) + " " + ((modifier2.mod_price > 0) ? '($' + modifier2.mod_price.toFixed(2) + ")" : '');
                                                                                }
                                                                                commaCount++;
                                                                            }

                                                                        }
                                                                    }


                                                                });

                                                                productModifier.push(modifier1.mod_id);

                                                                return (<div>{modifier}</div>);
                                                            }

                                                        })}{
                                                            (item.product_notes != "") ?
                                                                <div>{t('special_notes')}: {item.product_notes}</div>
                                                                : ''
                                                        }</td>
                                                    <td>{(parseInt(item.product_quantity) > 1) ? 'x' + item.product_quantity : ''}</td>

                                                    {(item.product_loyalty == "N") ?
                                                        <td>${(parseFloat(item.product_price)).toFixed(2)}</td>
                                                        : <td>{(parseFloat(item.product_loyalty_spent)).toFixed(0)} {t('points')}</td>}
                                                </tr>);
                                        })}
                                        </tbody>
                                    </table>

                                    <table className="summaryTable">
                                        <tbody>
                                        <tr>
                                            <td>Sub-
                                                Total
                                            </td>
                                            <td></td>
                                            <td> ${parseFloat(this.state.cartTotal).toFixed(2)}
                                            </td>
                                        </tr>
                                        {(this.state.discount > 0) ?

                                            <tr>
                                                <td>{t('discount')}
                                                </td>
                                                <td></td>
                                                <td>${parseFloat(this.state.discount).toFixed(2)}</td>
                                            </tr>
                                            : ''
                                        }
                                        {this.state.tax.map((tax, index) => {

                                            return (<tr key={tax.tax_id}>
                                                <td>{tax.tax_name} ({parseFloat(tax.tax_percentage).toFixed(2)}%)</td>
                                                <td></td>
                                                <td>${parseFloat(tax.tax_value).toFixed(2)}</td>
                                            </tr>);
                                        })}

                                        <tr style={{display: deliveryVisible}}>
                                            <td>{t('delivery_charge')}
                                            </td>
                                            <td></td>
                                            <td>${parseFloat(this.state.orderDeliveryFee).toFixed(2)}</td>
                                        </tr>
                                        {(this.state.tip > 0) ?

                                            <tr>
                                                <td>{t('tip')}
                                                </td>
                                                <td></td>
                                                <td>${parseFloat(this.state.tip).toFixed(2)}</td>
                                            </tr>
                                            : ''
                                        }
                                        {(this.state.nca > 0) ?
                                            <tr>
                                                <td>{this.state.ncaName}
                                                </td>
                                                <td></td>
                                                <td>${parseFloat(this.state.nca).toFixed(2)}</td>
                                            </tr>
                                            : ''
                                        }

                                        <tr className="total_num">
                                            <td>Total</td>
                                            <td></td>
                                            <td>${parseFloat(this.state.subTotal).toFixed(2)}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div className="form-group" style={{
                                        paddingLeft: "30px",
                                        paddingRight: "30px",
                                        marginTop: "20px",
                                        marginBottom: "60px"
                                    }}>
                                        <input type="button" name="reorderThis" id="reorderThis"
                                               value={t('reorder_this')}/>
                                    </div>
                                </div>

                            </div>
                            <div className="clearfix"></div>

                        </form>
                    </div>
                </div>


                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false}
                       open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('loading')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
                <div className="clearfix"></div>

            </div>
        );
    }
}

export default withRouter(withTranslation()(order_summary));


// WEBPACK FOOTER //
// ./src/view_components/order_summary.js